<template>
  <div class="activity-wrap" style="background: #F4F4F4;">
    <app-header />

    <div class="content">
      <p>
        <img src="../../assets/images/activity/_20241216/02.png" alt="" />
      </p>
      <p>
        <img src="../../assets/images/activity/_20241216/03.png" alt="" />
      </p>
      <p>
        <img src="../../assets/images/activity/_20241216/04.png" alt="" />
      </p>
      <p>
        <img src="../../assets/images/activity/_20241216/05.png" alt="" />
      </p>
      <p>
        <img src="../../assets/images/activity/_20241216/06.png" alt="" />
      </p>

      <div class="footer_1216">
        <div class="info">
          <img src="../../assets/images/activity/_20241216/07.png" alt="" @click="nowOpen()"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader
  },
  data() {
    return {
      s: this.$route.query.s
    };
  },
  watch: {},
  created() {
    if(!this.s){
      this.s = "";
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    nowOpen() {
      var routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: 116,month: 12}})
      let {href} = routerDate;
      window.location.href = href + "?s=" + this.s;
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  background: url("../../assets/images/activity/_20241216/01.jpg") no-repeat
    center top;
  text-align: center;
  padding-bottom: 180px;

  .footer_1216 {
    width: 100%;
    border-top: 3px solid #ff2601;
    background: #f4f4f4;
    margin-top: 80px;
    position: fixed;
    bottom: 0;
    left: 0;
    .info {
      width: 826px;
      margin: 0 auto;
      img {
        margin-top: -70px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/activity20240401.vue